export class SettingsPanelTab {
  private label?: string;
  private readonly tabId: string;
  private readonly controls: SettingsPanelTabControl[];

  constructor(tabId: string, controls: string[]) {
    this.tabId = tabId;
    this.controls = controls.map(SettingsPanelTab.normalizeControl);
  }

  public getTabId(): string {
    return this.tabId;
  }

  public getLabel(): string | undefined {
    return this.label;
  }

  public getControlsIds(): string[] {
    return this.controls.map(c => c.id);
  }

  public getControls(): SettingsPanelTabControl[] {
    return this.controls;
  }

  public withLabel(label: string): this {
    this.label = label;
    return this;
  }

  public addControl(control: string | SettingsPanelTabControlConfig, position: number): this {
    const normalized = SettingsPanelTab.normalizeControl(control);
    if (position < 0) {
      this.controls.unshift(normalized);
    } else if (position > this.controls.length) {
      this.controls.push(normalized);
    } else {
      this.controls.splice(position, 0, normalized);
    }
    return this;
  }

  public deleteControl(controlId: string): void {
    const index = this.controls.findIndex(c => c.id === controlId);
    if (index !== -1) {
      this.controls.splice(index, 1);
    }
  }

  private static normalizeControl(control: string | SettingsPanelTabControlConfig): SettingsPanelTabControl {
    if (typeof control === 'string') {
      return {id: control};
    }
    if (!control.id) {
      throw new Error('SettingsPanelTabControlConfig.id is required');
    }
    return {
      ...control,
      id: control.id,
    };
  }
}

export interface SettingsPanelTabControlConfig {
  id: string;
  class?: string;
  withFullHeight?: boolean;
}

export type SettingsPanelTabControl = SettingsPanelTabControlConfig;
